import React from "react";
import { Route, Routes } from "react-router-dom";

import { useAuthCheck } from "@hooks/useAuthCheck";
import { useTokenCheck } from "@hooks/useTokenCheck";
import { login, root } from "@constants/navlinks";
import { Login, Portal } from "@components/pages";

export const AppRouter = () => {
  useTokenCheck();
  useAuthCheck();

  return (
    <Routes>
      <Route path={login} Component={Login} />
      <Route path={root} Component={Portal} />

      <Route path="*" />
    </Routes>
  );
};
